import moment from 'moment-timezone-all'
import React from 'react'
import { START_OF_REPORTS } from 'ducks/reports/constants'
import {
  diff,
  getPreviousMonthFirstDayDate,
  getCurrentMonthFirstDayDate,
  relativeToAbsoluteDate,
} from 'util/date'
import { isObject } from 'util/objects'

import DatePickerPreset from './DatePickerPreset'
import styles from './styles.less'

const now = new Date()

export const DEFAULT_PRESETS = {
  this_1_day: 'Today',
  previous_1_day: 'Yesterday',
  previous_7_days: {
    title: 'Last 7 days',
    days: 7,
  },
  previous_4_weeks: { title: 'Last 4 weeks', days: 28 },
  this_1_month: {
    title: 'This month',
    days: diff('days', getCurrentMonthFirstDayDate(), now),
  },
  previous_1_month: {
    title: 'Last month',
    days: diff('days', getPreviousMonthFirstDayDate(), now),
  },
  all_time: {
    title: 'All time',
    days: 99999,
  },
}

function presetStartDate(key, today) {
  if (key === 'all_time') return moment(START_OF_REPORTS).format('YYYY-MM-DD')
  return relativeToAbsoluteDate(key, moment(today)).start
}

// Drops presets whose start date ('YYYY-MM-DD') is before minStartDate. Uses
// the real start date rather than `days`, which is approximate for some keys.
export function filterPresetsByMinStartDate(presets, minStartDate, today) {
  if (!minStartDate) return presets
  return Object.keys(presets).reduce((allowed, key) => {
    if (presetStartDate(key, today) >= minStartDate) {
      // eslint-disable-next-line no-param-reassign
      allowed[key] = presets[key]
    }
    return allowed
  }, {})
}

export default function DatePickerPresets({
  onApply,
  presets: allPresets = DEFAULT_PRESETS,
  presetMinStartDate,
  today,
}) {
  const presets = filterPresetsByMinStartDate(
    allPresets,
    presetMinStartDate,
    today
  )
  return (
    <div className={styles.DatePickerPresets}>
      <span>Ranges:</span>
      {Object.keys(presets).map(key => {
        const preset = presets[key]
        const presetObject = isObject(preset)
          ? preset
          : {
              title: preset,
            }
        return preset ? (
          <DatePickerPreset
            key={key}
            onApply={onApply}
            text={presetObject.title}
            timeframe={key}
            limit={presetObject.days}
          />
        ) : null
      })}
    </div>
  )
}
